import { createIcon } from '@chakra-ui/icons';

export const Wifi = createIcon({
  displayName: 'Wifi',
  viewBox: '0 0 10 9',
  path: [
    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2636_530)">
        <path
          d="M5.00029 8.2313C5.66303 8.2313 6.20029 7.69404 6.20029 7.0313C6.20029 6.36856 5.66303 5.8313 5.00029 5.8313C4.33755 5.8313 3.80029 6.36856 3.80029 7.0313C3.80029 7.69404 4.33755 8.2313 5.00029 8.2313Z"
          fill="currentColor"
        />
        <path
          d="M5 3.55664C6.09509 3.55664 7.07893 3.9606 7.83008 4.76953L7.89551 4.83984L6.96484 5.77051L6.89453 5.69238C6.40954 5.15351 5.70653 4.88086 5 4.88086C4.2936 4.88096 3.59134 5.15361 3.10645 5.69238L3.03516 5.77051L2.96094 5.69531L2.10547 4.83984L2.1709 4.76953C2.92196 3.9607 3.90507 3.55674 5 3.55664Z"
          fill="currentColor"
          stroke="#ADADAD"
          strokeWidth="0.2"
        />
        <path
          d="M5 1.02539C6.71291 1.02539 8.31301 1.65332 9.56934 2.85254L9.64062 2.9209L9.57324 2.99316L8.78516 3.83691L8.71484 3.91309L8.6416 3.83984C7.6487 2.84694 6.38094 2.34961 5 2.34961C3.61882 2.34961 2.34997 2.84691 1.35645 3.78516L1.28516 3.85156L0.356445 2.92285L0.430664 2.85254C1.68699 1.65332 3.28709 1.02539 5 1.02539Z"
          fill="currentColor"
          stroke="#ADADAD"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_2636_530">
          <rect width="10" height="9" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
